import * as React from 'react';
import Box from '@mui/material/Box';
import { ASSETS } from '../../utils/config';
import { Container, Row, StyledSlider, SelectedValue } from './AIBuilderSlider.styled';
import TextView from 'components/TextView';
import IyugaTooltip from 'components/IyugaTooltip';

export default function CustomAISlider({ label, steps, min, max, onChange, infoText, value }) {
  return (
    <Container>
      <Row>
        {/* Label with Tooltip beside it */}
        <div style={{ display: 'flex' }}>
          <TextView
            variant="text"
            style={{ fontWeight: 'bold', marginRight: '5px', fontSize: '12px' }}
          >
            {label}
          </TextView>
          {infoText && (
            <IyugaTooltip
              placement="top"
              tooltip={
                <TextView
                  style={{
                    fontWeight: '300',
                    color: '#123051',
                    fontSize: '12px',
                  }}
                >
                  {infoText}
                </TextView>
              }
            />
          )}
        </div>
        {/* Styled Display for Selected Value */}
        <SelectedValue>{value}</SelectedValue>
      </Row>
      <StyledSlider
        valueLabelDisplay="auto"
        value={value}
        onChange={onChange}
        step={steps}
        marks
        min={min}
        max={max}
        size="small"
      />
      <Row style={{ marginTop: '-8px' }}>
        <TextView variant="text" style={{ fontWeight: 'bold' }}>
          {min}
        </TextView>
        <TextView variant="text" style={{ color: '#6B6F80' }}>
          {(min + max) / 2}
        </TextView>
        <TextView variant="text" style={{ fontWeight: 'bold' }}>
          {max}
        </TextView>
      </Row>
    </Container>
  );
}
